__turbopack_context__.v({
  "active": "signIn-module-scss-module__p4N7xW__active",
  "activeSub": "signIn-module-scss-module__p4N7xW__activeSub",
  "dropdownIcon": "signIn-module-scss-module__p4N7xW__dropdownIcon",
  "fade-in": "signIn-module-scss-module__p4N7xW__fade-in",
  "hasSub": "signIn-module-scss-module__p4N7xW__hasSub",
  "inActive": "signIn-module-scss-module__p4N7xW__inActive",
  "inActiveSub": "signIn-module-scss-module__p4N7xW__inActiveSub",
  "link": "signIn-module-scss-module__p4N7xW__link",
  "menuSub": "signIn-module-scss-module__p4N7xW__menuSub",
  "menus": "signIn-module-scss-module__p4N7xW__menus",
  "navDropdown": "signIn-module-scss-module__p4N7xW__navDropdown",
  "navDropdownItem": "signIn-module-scss-module__p4N7xW__navDropdownItem",
  "navDropdownSub": "signIn-module-scss-module__p4N7xW__navDropdownSub",
  "signInButton": "signIn-module-scss-module__p4N7xW__signInButton",
  "signInContainer": "signIn-module-scss-module__p4N7xW__signInContainer",
  "signInWrapper": "signIn-module-scss-module__p4N7xW__signInWrapper",
});
